module.exports = __webpack_public_path__ + "img/huasheng.jpg";